export const htmlTemplateNav = () => `<div class="slider__arrow slider__arrow--prev">
              <div class="svg svg-arrow w-embed">
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="6"
                     height="11"
                     viewBox="0 0 6 11"
                     fill="none"
                     transform="rotate(180)">
                  <path d="M1 9.5L5 5.5L1 1.5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <div class="slider__arrow slider__arrow--next">
              <div class="svg svg-arrow w-embed">
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                  <path d="M1 9.5L5 5.5L1 1.5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <div class="swiper-pagination reviews__pagination"></div>`;
